<template>
  <div class="upload-table-screen">
    <el-table
      class="p-table"
      stripe
      border
      size="mini"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        prop="createdAt"
        label="Data"
        width="160"
        align="center"
        :formatter="formatarData"
      >
      </el-table-column>
      <el-table-column
        prop="nome"
        label="Nome do arquivo"
        min-width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="tipoArquivo.description"
        label="Tipo do arquivo"
        min-width="180"
      >
      </el-table-column>
      <el-table-column
        prop="statusProcessamento.description"
        label="Status"
        width="130"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            style="width:100px"
            :type="colorTag(scope.row.statusProcessamento)"
            disable-transitions
          >{{scope.row.statusProcessamento.description}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="notas"
        label="Notas"
        align="center"
        width="95"
      >
        <template
          slot-scope="scope"
          v-if="scope.row.notas"
        >
        <el-badge :value="scope.row.notas.length" class="item">
          <el-button
            plain
            size="small"
            @click="exibirNotas(scope.row.notas)"
          >
            <i class="el-icon-chat-line-square"></i>
          </el-button>
        </el-badge>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" 
            v-if="premiumUser() && validaAcesso(scope.row.userId)"
            effect="dark" :content="verificaData(scope.row.createdAt) ? 'Download expirado' : 'Download disponível'" placement="left-end">
            <span>
              <el-button type="primary" size="mini" :disabled="verificaData(scope.row.createdAt)" :loading="loading" @click="download(scope.row)"><i class="el-icon-download el-icon-right"></i> Download</el-button>
            </span>
          </el-tooltip>
          <el-button v-else size="mini" disabled class="no-drop" v-b-tooltip.hover title="Sem permissões"><i class="el-icon-download el-icon-right"></i> Download</el-button>
        </template>
        <template slot="header" slot-scope="scope">
          <div>
            <el-tooltip class="item" effect="dark" content="Os arquivos podem ser baixados até 30 dias após a realização do upload" placement="top">
              <span>Ação
                <i class="el-icon-info" style="margin-left: 5px;"></i>
              </span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <el-footer 
    class="text-center"
    style="padding-top:20px;">
        <el-button 
        class="float-right" 
        circle 
        @click="listar"
        style="position: absolute;bottom: 5px;right: 15px;"
        v-b-popover.hover.top="'Recarregar arquivos'">
          <i class="fas fa-sync-alt"></i>
        </el-button>
    </el-footer>

    <el-dialog
      title="Notas"
      :visible.sync="abrirNotas"
    >
    
      <el-alert
        v-for="(nota, index) in notasSelecionadas"
        :key="index"
        :title="nota"
        type="info"
        show-icon
        :closable="false"
      />
      <span
        slot="footer"
        class="dialog-footer btn-exportar"
      >
        <el-button
          type="success"
          v-if="notasSelecionadas.length > 0 && temAcesso('Arquivo','Exportar')"
          @click="exportarNotas()"
        >Exportar</el-button>
        <el-button
          disabled
          v-if="notasSelecionadas.length > 0 && !temAcesso('Arquivo','Exportar')"
          v-b-tooltip.hover title="Sem permissões" class="no-drop"
        >Exportar</el-button>
      </span>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="abrirNotas = false"
        >Fechar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from 'axios';
import { Loading } from 'element-ui'
const statusArquivo = {
  0: "warning",
  1: "primary",
  2: "success"
}

export default {
  name: 'UploadTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    listar: {
      type: Function,
      required: true,
    }
  },
  data () {
    return {
      abrirNotas: false,
      notasSelecionadas: [],
      loading:false
    };
  },
  methods: {
    formatarData (value) {
      return this.moment(value.updatedAt).format('DD/MM/YYYY hh:mm')
    },
    colorTag (data) {
      return statusArquivo[data.value]
    },
    exibirNotas(notas){
      this.notasSelecionadas = notas
      this.abrirNotas = true
    },
    exportarNotas(){
      const self = this;
       return self.$blob.postDownload(self.$urls.EXPORT_FILE_LIST_ERROR, this.notasSelecionadas, () => { 
      })
    },
    verificaData(data) {
      // Subtrai 30 dias da data atual
      const dataLimite = new Date();
      dataLimite.setDate(dataLimite.getDate() - 30);

      const dataComparacao = new Date(data);

      const isMenorQue30Dias = dataComparacao < dataLimite;
      return isMenorQue30Dias;
    },
    download(param) {
      this.loading = true;
      this.requestDownload(param._id);
    },
    callbackDownload(){
      this.loading = false;
      this.$message.success('Download concluido.');
    },
    callbackDownloadError(erro){
      this.loading = false;
      console.error('Erro na solicitação de download:', erro);
    },
    requestDownload(id){
      // exemplo de download sem o param callbackerror
      /* try {
        this.$blob.getDownload(`${this.$urls.ARQUIVO_DOWNLOAD}/${id}`, this.callbackDownload)
      } catch (error) {
        console.error('Erro na solicitação de download:', error);
        throw error;
      } finally {
        this.callbackDownloadError()
      } */

      this.$blob.getDownload(`${this.$urls.ARQUIVO_DOWNLOAD}/${id}`, this.callbackDownload, this.callbackDownloadError)
    },
    validaAcesso(userIdArquivo){
      var userData = JSON.parse(localStorage.getItem('user') || {});
      var user = userData.user;
      var claims = userData.claims;
      var isValid = claims.find(r => r.name === 'sysAdmin') || user._id === userIdArquivo
      return isValid;
    }
  }
}
</script>

<style lang="scss">
  .upload-table-screen {
     
  .cell{
    padding: 8px;
  }

  .el-alert{
    margin-bottom: 1rem !important;
  }

  .el-dialog__body {
    max-height: 55vh !important;
    overflow-y: scroll !important;
  }

  .el-dialog__body::-webkit-scrollbar {
      width: 6px;
      background-color: #F5F5F5;
  }

  .el-dialog__body::-webkit-scrollbar-thumb {
      background-color: #5e5e5e;
  }

  .el-dialog__body::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(54, 54, 54, 0.3);
      box-shadow: inset 0 0 6px rgba(54, 54, 54, 0.3);
      background-color: #F5F5F5;
  }

  .btn-exportar{
    float: left;
  }

  @media only screen and (max-width: 768px) {
    .el-dialog {
      width: 90% !important;
    }
  }
}

</style>
